import { StyledDashboardUserStatsItem, StyledDashboardUserStatsItemIcon } from "../dashboard-user-stats.style"


const DashboardUserStatsItem = ({ icon, title, count, color, bgColor }) => {
    return (
        <StyledDashboardUserStatsItem >
            <StyledDashboardUserStatsItemIcon color={color} bgColor={bgColor}>
                {icon}
            </StyledDashboardUserStatsItemIcon>
            <h2 className="item-title">{title}</h2>
            <h2 className="item-count">{count}</h2>
        </StyledDashboardUserStatsItem>
    )
}

export default DashboardUserStatsItem